var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('overview'),_c('main-contents'),_c('sub-contents'),_c('news')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }